import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlPillQuantityStyled } from './TrlPillQuantity.styles';

export const TrlPillQuantity = () => {
  return (
    <TrlPillQuantityStyled label={<FormattedMessage id="TRLT_UI-QUANTITY" />} />
  );
};
